export default "__VITE_ASSET__DCV_GdZ6__"